export default {
  create: async function (payload) {
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/user/session`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(payload),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  delete: async function (uuid) {
    const auth_token = await sessionStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/user/session`,
      {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: auth_token,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  get: async function () {
    const auth_token = await sessionStorage.getItem("token");
    var url = `${process.env.REACT_APP_API_BASE_URL}/user/session`;
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: auth_token,
      }),
    });
    const response = await fetch(request);
    const json = await response.json();
    return json;
  },
  validateToken: async function (jwtToken) {
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/authorization`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: jwtToken,
        }),
      }
    );

    console.log(
      "Validating token with API:",
      `${process.env.REACT_APP_API_BASE_URL}/authorization`
    );
    console.log("Token (first 50 chars):", jwtToken?.substring(0, 50) + "...");

    try {
      const response = await fetch(request);

      if (!response.ok) {
        return {
          status: response.status,
          data: null,
        };
      }

      const json = await response.json();
      return {
        status: json.status || response.status,
        data: json.data || null,
      };
    } catch (err) {
      return {
        status: 0,
        data: null,
      };
    }
  },
  redeemExchangeToken: async function (exchangeToken) {
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/auth/token/redeem`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          exchange_token: exchangeToken,
        }),
      }
    );

    try {
      const response = await fetch(request);

      if (!response.ok) {
        return {
          status: response.status,
          data: null,
        };
      }

      const json = await response.json();
      return {
        status: json.status || response.status,
        data: json.data || null,
      };
    } catch (err) {
      return {
        status: 0,
        data: null,
      };
    }
  },
};
